import React, { useState, useEffect, useRef } from 'react';
import { PlatformOverviewDemo, IntegrationsDemoVideo, BroadcasterDemo } from '../components/DemoVideos';
import { useNavigate } from 'react-router-dom';

/* ─── SVG Icon System ───────────────────────────────────────────────────────── */
function Icon({ name, size = 36, color = '#ef4444' }) {
  const s = { width: size, height: size, display: 'block' };
  const p = { fill: 'none', stroke: color, strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const icons = {
    bot:        <svg style={s} viewBox="0 0 24 24" {...p}><rect x="3" y="9" width="18" height="12" rx="3"/><path d="M9 9V7a3 3 0 016 0v2"/><circle cx="9" cy="15" r="1" fill={color} stroke="none"/><circle cx="15" cy="15" r="1" fill={color} stroke="none"/><path d="M9 19h6"/><path d="M12 3v2"/></svg>,
    broadcast:  <svg style={s} viewBox="0 0 24 24" {...p}><path d="M18.364 5.636a9 9 0 010 12.728M15.536 8.464a5 5 0 010 7.072M12 12h.01"/><path d="M5.636 5.636a9 9 0 000 12.728"/><path d="M8.464 8.464a5 5 0 000 7.072"/><circle cx="12" cy="12" r="1.5" fill={color} stroke="none"/></svg>,
    brain:      <svg style={s} viewBox="0 0 24 24" {...p}><path d="M12 5a7 7 0 00-7 7c0 2.5 1.5 4 3 5v2h8v-2c1.5-1 3-2.5 3-5a7 7 0 00-7-7z"/><path d="M12 5V3"/><path d="M9 12h6"/><path d="M9 15h6"/><circle cx="12" cy="9" r="1" fill={color} stroke="none"/></svg>,
    book:       <svg style={s} viewBox="0 0 24 24" {...p}><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/><path d="M8 7h8"/><path d="M8 11h8"/><path d="M8 15h5"/></svg>,
    target:     <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2" fill={color} stroke="none"/><path d="M22 12h-4M6 12H2M12 6V2M12 22v-4"/></svg>,
    calendar:   <svg style={s} viewBox="0 0 24 24" {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><circle cx="12" cy="16" r="1.5" fill={color} stroke="none"/></svg>,
    globe:      <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>,
    handoff:    <svg style={s} viewBox="0 0 24 24" {...p}><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 2v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
    upload:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>,
    palette:    <svg style={s} viewBox="0 0 24 24" {...p}><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 011.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/><circle cx="6.5" cy="11.5" r="1.5" fill={color} stroke="none"/><circle cx="9.5" cy="7.5" r="1.5" fill={color} stroke="none"/><circle cx="14.5" cy="7.5" r="1.5" fill={color} stroke="none"/><circle cx="17.5" cy="11.5" r="1.5" fill={color} stroke="none"/></svg>,
    users:      <svg style={s} viewBox="0 0 24 24" {...p}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.74"/></svg>,
    barchart:   <svg style={s} viewBox="0 0 24 24" {...p}><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>,
    clock:      <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    shield:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>,
    building:   <svg style={s} viewBox="0 0 24 24" {...p}><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/><path d="M6 12h4"/><path d="M14 12h4"/><path d="M6 16h4"/><path d="M14 16h4"/></svg>,
    settings:   <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>,
    rocket:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>,
    flag:       <svg style={s} viewBox="0 0 24 24" {...p}><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>,
    zap:        <svg style={s} viewBox="0 0 24 24" {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill={`${color}20`} stroke={color}/></svg>,
    lock:       <svg style={s} viewBox="0 0 24 24" {...p}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/><circle cx="12" cy="16" r="1.5" fill={color} stroke="none"/></svg>,
    trending:   <svg style={s} viewBox="0 0 24 24" {...p}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
    handshake:  <svg style={s} viewBox="0 0 24 24" {...p}><path d="M20.42 4.58a5.4 5.4 0 00-7.65 0l-.77.78-.77-.78a5.4 5.4 0 00-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"/><path d="M12 5.36L8.87 8.5a2.13 2.13 0 000 3"/><path d="M15 8.5a2.13 2.13 0 010 3l-3.87 3.86"/></svg>,
    plug:       <svg style={s} viewBox="0 0 24 24" {...p}><path d="M12 22v-5"/><path d="M9 8V2"/><path d="M15 8V2"/><path d="M18 8H6a2 2 0 00-2 2v3a6 6 0 006 6h4a6 6 0 006-6v-3a2 2 0 00-2-2z"/></svg>,
  };
  return icons[name] || null;
}

/* ─── CSS Keyframes & Utilities ─────────────────────────────────────────────── */
const GLOBAL_CSS = `
  @keyframes floatOrb1 {
    0%, 100% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(40px, -50px) scale(1.06); }
    66% { transform: translate(-25px, 25px) scale(0.94); }
  }
  @keyframes floatOrb2 {
    0%, 100% { transform: translate(0px, 0px) scale(1); }
    50% { transform: translate(-50px, 35px) scale(1.1); }
  }
  @keyframes floatOrb3 {
    0%, 100% { transform: translate(0px, 0px); }
    25% { transform: translate(20px, -30px); }
    75% { transform: translate(-30px, 15px); }
  }
  @keyframes marqueeScroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  @keyframes typingBounce {
    0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
    30% { transform: translateY(-5px); opacity: 1; }
  }
  @keyframes slideInMsg {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeUpIn {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes glowPulse {
    0%, 100% { box-shadow: 0 0 20px rgba(239,68,68,0.3); }
    50%      { box-shadow: 0 0 40px rgba(239,68,68,0.6); }
  }
  @keyframes barFill {
    from { width: 0; }
    to   { width: var(--w); }
  }
  .mx-fade-up {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.65s ease, transform 0.65s ease;
  }
  .mx-fade-up.mx-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .mx-delay-1 { transition-delay: 0.1s; }
  .mx-delay-2 { transition-delay: 0.2s; }
  .mx-delay-3 { transition-delay: 0.3s; }
  .mx-delay-4 { transition-delay: 0.4s; }

  @keyframes shimmer {
    0%   { transform: translateX(-100%); }
    100% { transform: translateX(200%); }
  }
  @keyframes beamSweep {
    0%   { opacity: 0; left: -20%; }
    20%  { opacity: 1; }
    80%  { opacity: 1; }
    100% { opacity: 0; left: 120%; }
  }
  @keyframes particleFloat {
    0%, 100% { transform: translateY(0px) scale(1); opacity: 0.5; }
    50%       { transform: translateY(-22px) scale(1.15); opacity: 1; }
  }
  @keyframes borderGlow {
    0%, 100% { box-shadow: 0 0 0 1px rgba(239,68,68,0.2), 0 0 24px rgba(239,68,68,0.08); }
    50%       { box-shadow: 0 0 0 1px rgba(239,68,68,0.5), 0 0 48px rgba(239,68,68,0.2); }
  }
  @keyframes floatCard {
    0%, 100% { transform: translateY(0px) rotate(-0.5deg); }
    50%       { transform: translateY(-14px) rotate(0.5deg); }
  }
  @keyframes gradientShift {
    0%   { background-position: 0% 50%; }
    50%  { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  @keyframes dataLine {
    0%   { stroke-dashoffset: 200; opacity: 0; }
    30%  { opacity: 1; }
    100% { stroke-dashoffset: 0; opacity: 0.6; }
  }
  @keyframes iconBounce {
    0%, 100% { transform: translateY(0); }
    40%       { transform: translateY(-6px); }
    60%       { transform: translateY(-3px); }
  }
  @keyframes scanLine {
    0%   { top: 0%; opacity: 0; }
    5%   { opacity: 0.6; }
    95%  { opacity: 0.6; }
    100% { top: 100%; opacity: 0; }
  }
  @keyframes videoGlow {
    0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.4); }
    50%       { box-shadow: 0 0 0 12px rgba(239,68,68,0); }
  }
  .shimmer-cta { position: relative; overflow: hidden; }
  .shimmer-cta::after {
    content: '';
    position: absolute;
    top: 0; width: 40%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent);
    animation: shimmer 2.8s ease-in-out infinite;
    pointer-events: none;
  }
  .glow-border { animation: borderGlow 3s ease-in-out infinite; }
  .float-card  { animation: floatCard 5s ease-in-out infinite; }

  /* ── Responsive ─────────────────────────────────────────── */
  @media (max-width: 800px) {
    .mx-nav-links { display: none !important; }
    .mx-nav-cta   { display: none !important; }
    .mx-hero-inner {
      flex-direction: column !important;
      padding: 36px 20px 60px !important;
      gap: 40px !important;
    }
    .mx-hero-phone { display: none !important; }
    .mx-hero-btns  { flex-direction: column !important; align-items: flex-start !important; }
    .mx-hero-stats { gap: 20px !important; }
    .mx-section-px { padding-left: 20px !important; padding-right: 20px !important; }
    .mx-demo-sidebar { display: none !important; }
    .mx-integrations-pills { flex-direction: column !important; align-items: flex-start !important; gap: 8px !important; }
    .mx-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
    .mx-nav-cta-mobile { display: block !important; }
  }
`;


function useFadeUp() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('mx-visible'); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll('.mx-fade-up').forEach(el => obs.observe(el));
    return () => obs.disconnect();
  });
}

/* ─── Root ──────────────────────────────────────────────────────────────────── */
const BAR_H  = 44;  // announcement bar height px
const NAV_H  = 68;  // navbar height px

export default function LandingPage() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen]     = useState(false);
  const [modalPreset, setModalPreset] = useState('');
  const [barVisible, setBarVisible]   = useState(true);

  function openLead(preset = '') {
    setModalPreset(preset);
    setModalOpen(true);
  }

  useEffect(() => {
    const s = document.createElement('style');
    s.id = 'mx-global-css';
    if (!document.getElementById('mx-global-css')) {
      s.textContent = GLOBAL_CSS;
      document.head.appendChild(s);
    }
    return () => { const el = document.getElementById('mx-global-css'); if (el) el.remove(); };
  }, []);

  useFadeUp();

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", background: '#0a0a0a', color: '#ffffff', overflowX: 'hidden' }}>
      <Navbar navigate={navigate} openLead={openLead} barVisible={barVisible} />
      <AnnouncementBar visible={barVisible} onDismiss={() => setBarVisible(false)} />
      <HeroSection navigate={navigate} openLead={openLead} barVisible={barVisible} />
      <StatsBelt />
      <ProductsSection navigate={navigate} openLead={openLead} />
      <VideoShowcase />
      <AIAgentFeatures />
      <SupportAgentSection />
      <IntegrationsSection />
      <BroadcasterFeatures />
      <HowItWorks />
      <PricingSection navigate={navigate} openLead={openLead} />
      <WhyMaxxcom />
      <Testimonials />
      <FAQSection />
      <CTABanner navigate={navigate} openLead={openLead} />
      <Footer />
      {modalOpen && <LeadCaptureModal preset={modalPreset} onClose={() => setModalOpen(false)} />}
    </div>
  );
}

/* ─── Lead Capture Modal ────────────────────────────────────────────────────── */
function LeadCaptureModal({ preset, onClose }) {
  const [form, setForm] = useState({
    name: '', phone: '', designation: '', companyEmail: '',
    companyName: '', companySize: '1–10', licenseRequired: preset || 'AI Agent',
  });
  const [step, setStep] = useState('form'); // 'form' | 'success' | 'error'
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  function set(field, value) { setForm(f => ({ ...f, [field]: value })); setErrors(e => ({ ...e, [field]: '' })); }

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = 'Required';
    if (!form.phone.trim()) e.phone = 'Required';
    if (!/^\d{10}$/.test(form.phone.replace(/\s/g, ''))) e.phone = 'Enter a valid 10-digit number';
    if (!form.companyEmail.trim()) e.companyEmail = 'Required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.companyEmail)) e.companyEmail = 'Enter a valid email';
    if (!form.companyName.trim()) e.companyName = 'Required';
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitting(true);
    try {
      // Get reCAPTCHA v3 token if site key is configured
      let recaptchaToken = '';
      const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
      if (siteKey && window.grecaptcha) {
        try { recaptchaToken = await window.grecaptcha.execute(siteKey, { action: 'submit_inquiry' }); }
        catch (_) {}
      }
      const res = await fetch('/api/inquiries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, recaptchaToken }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Submit failed');
      setStep('success');
    } catch (err) {
      console.error(err);
      setStep('error');
    }
    setSubmitting(false);
  }

  // Load reCAPTCHA v3 script on mount if site key is configured
  useEffect(() => {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (siteKey && !window.grecaptcha && !document.getElementById('rc-script')) {
      const s = document.createElement('script');
      s.id = 'rc-script';
      s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);

  // Trap focus on Escape
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '20px', animation: 'fadeUpIn 0.25s ease both',
      }}
    >
      <div style={{
        background: '#111111', border: '1px solid #2a2a2a', borderRadius: 24,
        width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto',
        position: 'relative',
      }}>
        {/* Close */}
        <button onClick={onClose} style={{ position: 'absolute', top: 18, right: 18, background: 'transparent', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 22, lineHeight: 1, zIndex: 1 }}>×</button>

        <div style={{ padding: '36px 40px' }}>
          {step === 'success' ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#14532d', border: '2px solid #22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12 }}>We've received your interest!</h2>
              <p style={{ fontSize: 15, color: '#64748b', lineHeight: 1.7, marginBottom: 28 }}>
                Our team will reach out to you within <strong style={{ color: '#ef4444' }}>2 business hours</strong> on your phone or email to discuss next steps.
              </p>
              <button onClick={onClose} style={{ padding: '12px 32px', borderRadius: 10, background: '#ef4444', border: 'none', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
                Close
              </button>
            </div>
          ) : step === 'error' ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#7f1d1d', border: '2px solid #ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/><circle cx="12" cy="12" r="10"/></svg>
              </div>
              <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12 }}>Something went wrong</h2>
              <p style={{ fontSize: 15, color: '#64748b', lineHeight: 1.7, marginBottom: 12 }}>
                We couldn't save your inquiry right now. Please reach out directly:
              </p>
              <a href="mailto:support@acceleratorx.co" style={{ color: '#ef4444', fontWeight: 700, fontSize: 15, textDecoration: 'none' }}>support@acceleratorx.co</a>
              <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'center' }}>
                <button onClick={() => setStep('form')} style={{ padding: '10px 24px', borderRadius: 10, background: 'transparent', border: '1px solid #334155', color: '#94a3b8', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Try Again</button>
                <button onClick={onClose} style={{ padding: '10px 24px', borderRadius: 10, background: '#ef4444', border: 'none', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>Close</button>
              </div>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: 28 }}>
                <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Request a Demo</h2>
                <p style={{ fontSize: 14, color: '#64748b' }}>Our team will get back to you within 2 hours.</p>
              </div>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {/* Row: Name + Phone */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <FormField label="Full Name *" error={errors.name}>
                    <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="Rajesh Mehta" style={iStyle(errors.name)} />
                  </FormField>
                  <FormField label="Phone Number *" error={errors.phone}>
                    <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="9876543210" style={iStyle(errors.phone)} type="tel" />
                  </FormField>
                </div>

                {/* Row: Designation + Company Name */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <FormField label="Designation">
                    <input value={form.designation} onChange={e => set('designation', e.target.value)} placeholder="Founder / Head of Marketing" style={iStyle()} />
                  </FormField>
                  <FormField label="Company Name *" error={errors.companyName}>
                    <input value={form.companyName} onChange={e => set('companyName', e.target.value)} placeholder="Acme Pvt. Ltd." style={iStyle(errors.companyName)} />
                  </FormField>
                </div>

                {/* Company Email */}
                <FormField label="Company Email *" error={errors.companyEmail}>
                  <input value={form.companyEmail} onChange={e => set('companyEmail', e.target.value)} placeholder="you@company.com" style={iStyle(errors.companyEmail)} type="email" />
                </FormField>

                {/* Row: Company Size + License */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <FormField label="Company Size">
                    <select value={form.companySize} onChange={e => set('companySize', e.target.value)} style={iStyle()}>
                      {['1–10', '11–50', '51–200', '201–500', '500+'].map(s => <option key={s}>{s}</option>)}
                    </select>
                  </FormField>
                  <FormField label="License Required *">
                    <select value={form.licenseRequired} onChange={e => set('licenseRequired', e.target.value)} style={iStyle()}>
                      {['AI Agent', 'Broadcaster', 'Both'].map(s => <option key={s}>{s}</option>)}
                    </select>
                  </FormField>
                </div>

                <button type="submit" disabled={submitting} style={{
                  marginTop: 4, padding: '14px', borderRadius: 12, border: 'none',
                  background: submitting ? '#7f1d1d' : '#ef4444', color: '#fff',
                  fontSize: 15, fontWeight: 700, cursor: submitting ? 'not-allowed' : 'pointer',
                  transition: 'background 0.2s',
                }}>
                  {submitting ? 'Submitting…' : 'Submit — Get a Demo →'}
                </button>

                <p style={{ fontSize: 12, color: '#374151', textAlign: 'center' }}>
                  By submitting, you agree to be contacted by the Maxxcom by AcceleratorX team.
                </p>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function FormField({ label, error, children }) {
  return (
    <div>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#94a3b8', marginBottom: 6, letterSpacing: 0.3 }}>{label}</label>
      {children}
      {error && <div style={{ fontSize: 11, color: '#ef4444', marginTop: 4 }}>{error}</div>}
    </div>
  );
}

function iStyle(error) {
  return {
    width: '100%', padding: '10px 12px', background: '#1a1a1a',
    border: `1px solid ${error ? '#ef4444' : '#2a2a2a'}`, borderRadius: 8,
    color: '#f1f5f9', fontSize: 14, outline: 'none', fontFamily: 'inherit',
    appearance: 'none',
  };
}

/* ─── Announcement Bar ──────────────────────────────────────────────────────── */
function AnnouncementBar({ visible, onDismiss }) {
  if (!visible) return null;
  return (
    <div style={{
      position: 'fixed', top: NAV_H, left: 0, right: 0, zIndex: 999,
      height: BAR_H,
      background: 'linear-gradient(90deg, #ef4444 0%, #b91c1c 100%)',
      padding: '0 24px', display: 'flex', alignItems: 'center',
      justifyContent: 'center', gap: 12,
    }}>
      <span style={{ fontSize: 13, fontWeight: 600, color: '#fff', textAlign: 'center' }}>
        Introducing AI WhatsApp Agents — 24/7 automated conversations, zero effort. Starting ₹10,000/month
      </span>
      <span style={{
        fontSize: 11, fontWeight: 700, color: '#fff',
        background: 'rgba(0,0,0,0.2)', borderRadius: 20, padding: '3px 10px',
        flexShrink: 0,
      }}>
        India's #1
      </span>
      <button
        onClick={onDismiss}
        style={{ position: 'absolute', right: 16, background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 18, opacity: 0.7, lineHeight: 1, padding: 4 }}
      >×</button>
    </div>
  );
}

/* ─── Navbar ─────────────────────────────────────────────────────────────────── */
function Navbar({ navigate, openLead, barVisible }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1001,
    height: NAV_H,
    background: scrolled ? 'rgba(10,10,10,0.95)' : 'rgba(10,10,10,0.6)',
    backdropFilter: 'blur(16px)',
    borderBottom: scrolled ? '1px solid rgba(255,255,255,0.07)' : '1px solid transparent',
    padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    transition: 'background 0.3s, border-color 0.3s',
  };

  return (
    <nav className="mx-section-px" style={navStyle}>
      <a href="#home" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
        <img src="/maxxcom-logo.svg" alt="Maxxcom by AcceleratorX" style={{ height: 36, objectFit: 'contain' }} />
        <div style={{ borderLeft: '1px solid rgba(255,255,255,0.1)', paddingLeft: 10, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span style={{ fontSize: 11, fontWeight: 800, color: '#f1f5f9', letterSpacing: 0.5, lineHeight: 1 }}>MAXXCOM</span>
          <span style={{ fontSize: 9, color: '#475569', letterSpacing: 0.3, lineHeight: 1, display: 'flex', alignItems: 'center', gap: 4 }}>
            by <img src="/acceleratorx-logo.webp" alt="AcceleratorX" style={{ height: 10, objectFit: 'contain', verticalAlign: 'middle' }} />
          </span>
        </div>
      </a>

      <div className="mx-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 36 }}>
        {[['Products', '#products'], ['Features', '#features'], ['Pricing', '#pricing'], ['FAQ', '#faq']].map(([label, href]) => (
          <a key={label} href={href} style={{ color: '#94a3b8', fontSize: 14, fontWeight: 500, textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = '#ef4444'}
            onMouseLeave={e => e.target.style.color = '#94a3b8'}
          >{label}</a>
        ))}
      </div>

      <div className="mx-nav-cta" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <NavBtn label="Login" onClick={() => navigate('/login')} outline />
        <NavBtn label="Get Started →" onClick={() => openLead()} />
      </div>
      {/* Mobile CTA — only shown when nav-cta is hidden */}
      <button
        className="mx-nav-cta-mobile"
        onClick={() => openLead()}
        style={{
          display: 'none', padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 700,
          background: '#ef4444', border: 'none', color: '#0a0a0a', cursor: 'pointer',
        }}
      >Get Started</button>
    </nav>
  );
}

function NavBtn({ label, onClick, outline }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        padding: '9px 22px', borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s',
        ...(outline
          ? { background: 'transparent', border: `1px solid ${h ? '#ef4444' : '#334155'}`, color: h ? '#ef4444' : '#e2e8f0' }
          : { background: h ? '#dc2626' : '#ef4444', border: 'none', color: '#0a0a0a', boxShadow: h ? '0 0 20px rgba(239,68,68,0.4)' : 'none' }
        ),
      }}
    >{label}</button>
  );
}

/* ─── Hero Section ───────────────────────────────────────────────────────────── */
function HeroSection({ navigate, openLead, barVisible }) {
  const topOffset = NAV_H + (barVisible ? BAR_H : 0);
  return (
    <section id="home" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      paddingTop: topOffset, position: 'relative', overflow: 'hidden',
    }}>
      {/* Orbs */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
        <div style={{
          position: 'absolute', width: 600, height: 600, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(239,68,68,0.12) 0%, transparent 70%)',
          top: '-10%', left: '-5%', animation: 'floatOrb1 14s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', width: 500, height: 500, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(185,28,28,0.14) 0%, transparent 70%)',
          top: '20%', right: '-8%', animation: 'floatOrb2 18s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', width: 300, height: 300, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(239,68,68,0.08) 0%, transparent 70%)',
          bottom: '10%', left: '40%', animation: 'floatOrb3 20s ease-in-out infinite',
        }} />
      </div>

      <div className="mx-hero-inner" style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 40px', display: 'flex', alignItems: 'center', gap: 80, width: '100%', position: 'relative', zIndex: 1, boxSizing: 'border-box' }}>
        {/* Left */}
        <div style={{ flex: 1 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 24,
            padding: '6px 16px', borderRadius: 100,
            background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)',
            fontSize: 13, color: '#ef4444', fontWeight: 600, animation: 'fadeUpIn 0.6s ease both',
          }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#ef4444', animation: 'glowPulse 2s ease infinite' }} />
            India's #1 WhatsApp AI Platform
          </div>

          <h1 style={{
            fontSize: 'clamp(38px, 5vw, 64px)', fontWeight: 900, lineHeight: 1.1,
            marginBottom: 24, animation: 'fadeUpIn 0.7s ease 0.1s both',
            letterSpacing: '-1.5px',
          }}>
            WhatsApp That<br />
            <span style={{ color: '#ef4444' }}>Works For You</span><br />
            <span style={{ color: '#b91c1c' }}>While You Sleep</span>
          </h1>

          <p style={{
            fontSize: 18, color: '#94a3b8', lineHeight: 1.8, marginBottom: 36, maxWidth: 520,
            animation: 'fadeUpIn 0.7s ease 0.2s both',
          }}>
            Deploy AI WhatsApp Agents that handle customer queries 24/7, check your calendar, query your CRM, search the web, and call any API — all on autopilot.
          </p>

          <div className="mx-hero-btns" style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 44, animation: 'fadeUpIn 0.7s ease 0.3s both' }}>
            <HeroBtn primary label="Start Free Trial →" onClick={() => openLead()} />
            <HeroBtn label="Watch Demo ▶" onClick={() => {}} />
          </div>

          <div className="mx-hero-stats" style={{ display: 'flex', gap: 32, animation: 'fadeUpIn 0.7s ease 0.4s both' }}>
            {[['500+', 'Businesses'], ['10M+', 'Messages Sent'], ['99.9%', 'Uptime SLA']].map(([val, lbl]) => (
              <div key={lbl}>
                <div style={{ fontSize: 26, fontWeight: 800, color: '#ef4444' }}>{val}</div>
                <div style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>{lbl}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right — Phone Mockup */}
        <div className="mx-hero-phone" style={{ flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}

function HeroBtn({ label, onClick, primary }) {
  const [h, setH] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      className={primary ? 'shimmer-cta' : ''}
      style={{
        padding: '14px 28px', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: 'pointer', transition: 'all 0.25s',
        ...(primary
          ? { background: h ? '#dc2626' : '#ef4444', border: 'none', color: '#0a0a0a', boxShadow: h ? '0 8px 32px rgba(239,68,68,0.5)' : '0 4px 20px rgba(239,68,68,0.3)' }
          : { background: 'transparent', border: `1px solid ${h ? '#ef4444' : '#334155'}`, color: h ? '#ef4444' : '#e2e8f0' }
        ),
      }}
    >{label}</button>
  );
}

function PhoneMockup() {
  const CONVOS = [
    [
      { type: 'in',  text: 'What meetings do I have tomorrow?' },
      { type: 'tool', text: 'Checking Google Calendar…' },
      { type: 'out', text: 'Tomorrow you have:\n— 10:00 AM · Team Standup (30 min)\n— 2:30 PM · Client Demo: Arjun & Co.' },
      { type: 'in',  text: 'Great! Any conflicts at 4 PM?' },
      { type: 'out', text: '4 PM is free — want me to block it?' },
    ],
    [
      { type: 'in',  text: 'Find contact info for Priya Sharma in our CRM' },
      { type: 'tool', text: 'Querying HubSpot CRM…' },
      { type: 'out', text: 'Priya Sharma\npriya@fashionhub.in\n+91 98765 43210\nStage: Qualified Lead' },
      { type: 'in',  text: 'What\'s the current gold rate?' },
      { type: 'tool', text: 'Searching the web…' },
      { type: 'out', text: 'Gold rate today: ₹72,450/10g (MCX). Up 0.4% from yesterday.' },
    ],
    [
      { type: 'in',  text: 'Hi! I need help with admission details' },
      { type: 'out', text: 'Happy to help. Which program are you interested in?' },
      { type: 'in',  text: 'Data Science — what\'s the fee?' },
      { type: 'out', text: 'Data Science Program:\n— Duration: 6 months\n— Fee: ₹45,000\n— Starts: May 15th\n\nWant me to schedule a counseling call?' },
      { type: 'in',  text: 'Yes please, tomorrow 11 AM?' },
      { type: 'out', text: 'Scheduled! You\'ll get a WhatsApp reminder.' },
    ],
  ];

  const [convoIdx, setConvoIdx] = useState(0);
  const messages = CONVOS[convoIdx];
  const [shown, setShown] = useState(1);
  const [typing, setTyping] = useState(false);

  useEffect(() => {
    if (shown >= messages.length) {
      // Pause then switch conversation
      const t = setTimeout(() => { setConvoIdx(c => (c + 1) % CONVOS.length); setShown(1); }, 2800);
      return () => clearTimeout(t);
    }
    setTyping(true);
    const t1 = setTimeout(() => {
      setTyping(false);
      setShown(s => s + 1);
    }, messages[shown]?.type === 'tool' ? 900 : 1500);
    return () => clearTimeout(t1);
  }, [shown, convoIdx]); // eslint-disable-line

  return (
    <div style={{
      width: 280, background: '#0f172a', borderRadius: 36, border: '6px solid #1e293b',
      boxShadow: '0 40px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(239,68,68,0.1)',
      overflow: 'hidden', position: 'relative',
    }}>
      {/* Status bar */}
      <div style={{ background: '#1a2840', padding: '12px 20px 10px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #ef4444, #b91c1c)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="bot" size={20} color="#fff" /></div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#f1f5f9' }}>MaxxBot</div>
          <div style={{ fontSize: 11, color: '#ef4444', display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#ef4444', display: 'inline-block' }} />online
          </div>
        </div>
      </div>

      {/* Chat area */}
      <div style={{ padding: '16px 12px', minHeight: 320, background: '#0f172a', display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'hidden' }}>
        {messages.slice(0, shown).map((m, i) => (
          <div key={`${convoIdx}-${i}`} style={{
            display: 'flex',
            justifyContent: m.type === 'tool' ? 'center' : m.type === 'out' ? 'flex-end' : 'flex-start',
            animation: 'slideInMsg 0.35s ease both',
          }}>
            {m.type === 'tool' ? (
              <div style={{
                fontSize: 10.5, color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
                padding: '4px 10px', borderRadius: 20, fontWeight: 600, letterSpacing: 0.3,
              }}>{m.text}</div>
            ) : (
              <div style={{
                maxWidth: '80%', padding: '8px 12px',
                borderRadius: m.type === 'out' ? '16px 4px 16px 16px' : '4px 16px 16px 16px',
                background: m.type === 'out' ? 'linear-gradient(135deg, #ef4444, #dc2626)' : '#1e293b',
                color: m.type === 'out' ? '#0a0a0a' : '#f1f5f9',
                fontSize: 11.5, fontWeight: m.type === 'out' ? 600 : 400, lineHeight: 1.55,
                whiteSpace: 'pre-line',
              }}>
                {m.text}
              </div>
            )}
          </div>
        ))}
        {typing && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ background: 'linear-gradient(135deg, #ef4444, #dc2626)', padding: '10px 16px', borderRadius: '16px 4px 16px 16px', display: 'flex', gap: 4, alignItems: 'center' }}>
              {[0, 0.15, 0.3].map((d, i) => (
                <span key={i} style={{ width: 6, height: 6, borderRadius: '50%', background: '#0a0a0a', display: 'inline-block', animation: `typingBounce 0.9s ease ${d}s infinite` }} />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Input bar */}
      <div style={{ background: '#1e293b', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ flex: 1, background: '#0f172a', borderRadius: 20, padding: '8px 14px', fontSize: 12, color: '#475569' }}>Type a message...</div>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>▶</div>
      </div>
    </div>
  );
}


/* ─── Products Section ───────────────────────────────────────────────────────── */
function ProductsSection({ navigate, openLead }) {
  return (
    <section id="products" className="mx-section-px" style={{ padding: '100px 40px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="Our Products" />
          <h2 style={{ fontSize: 'clamp(30px, 4vw, 48px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Two Powerful Tools,<br /><span style={{ color: '#ef4444' }}>One Platform</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 520, margin: '0 auto' }}>
            Whether you need intelligent conversations or mass outreach — Maxxcom has you covered.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 28 }}>
          <ProductCard
            gradient="linear-gradient(135deg, rgba(239,68,68,0.1) 0%, rgba(239,68,68,0.02) 100%)"
            border="rgba(239,68,68,0.2)"
            glow="rgba(239,68,68,0.15)"
            icon={<Icon name="bot" size={44} />}
            tag="AI Agent"
            tagColor="#ef4444"
            title="WhatsApp AI Agent"
            desc="Deploy a 24/7 AI agent on WhatsApp that qualifies leads, answers queries, books appointments, and nurtures customers — all on autopilot."
            features={['Groq + Llama 3.3 70B engine', 'Live Google Calendar access', 'HubSpot & CRM lookup', 'Real-time web search', 'Custom API tool builder', 'Lead capture & smart follow-ups']}
            price="₹10,000"
            cta="Start with AI Agent →"
            onClick={() => openLead('AI Agent')}
          />
          <ProductCard
            gradient="linear-gradient(135deg, rgba(185,28,28,0.1) 0%, rgba(185,28,28,0.02) 100%)"
            border="rgba(185,28,28,0.3)"
            glow="rgba(185,28,28,0.15)"
            icon={<Icon name="broadcast" size={44} color="#b91c1c" />}
            tag="Broadcaster"
            tagColor="#b91c1c"
            title="WhatsApp Broadcaster"
            desc="Send unlimited bulk messages to your contact lists with personalisation, rich media, and delivery insights — without getting banned."
            features={['Unlimited bulk messaging', 'Rich media support', 'Contact list management', 'Delivery & read receipts', 'Campaign scheduling']}
            price="₹6,999"
            cta="Start Broadcasting →"
            onClick={() => openLead('Broadcaster')}
          />
        </div>
      </div>
    </section>
  );
}

function ProductCard({ gradient, border, glow, icon, tag, tagColor, title, desc, features, price, cta, onClick }) {
  const [h, setH] = useState(false);
  return (
    <div
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      className="mx-fade-up"
      style={{
        background: h ? gradient : 'rgba(255,255,255,0.02)',
        border: `1px solid ${h ? border : 'rgba(255,255,255,0.06)'}`,
        borderRadius: 24, padding: '40px 36px',
        boxShadow: h ? `0 20px 60px ${glow}` : 'none',
        transition: 'all 0.35s', display: 'flex', flexDirection: 'column',
      }}
    >
      <div style={{ marginBottom: 20 }}>{icon}</div>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 16, padding: '4px 12px', borderRadius: 20, background: `${tagColor}15`, border: `1px solid ${tagColor}30`, width: 'fit-content' }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: tagColor, letterSpacing: 0.5 }}>{tag}</span>
      </div>
      <h3 style={{ fontSize: 24, fontWeight: 800, marginBottom: 14, letterSpacing: '-0.5px' }}>{title}</h3>
      <p style={{ fontSize: 15, color: '#64748b', lineHeight: 1.7, marginBottom: 28, flex: 1 }}>{desc}</p>
      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {features.map((f, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#94a3b8' }}>
            <span style={{ color: tagColor, fontWeight: 700, fontSize: 16 }}>✓</span>{f}
          </li>
        ))}
      </ul>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 24 }}>
        <div style={{ marginBottom: 16 }}>
          <span style={{ fontSize: 32, fontWeight: 900, color: tagColor }}>{price}</span>
          <span style={{ fontSize: 14, color: '#475569' }}>/month</span>
        </div>
        <button onClick={onClick} style={{
          width: '100%', padding: '14px', borderRadius: 12, border: 'none',
          background: h ? tagColor : `${tagColor}20`, color: h ? '#0a0a0a' : tagColor,
          fontSize: 15, fontWeight: 700, cursor: 'pointer', transition: 'all 0.25s',
          boxShadow: h ? `0 8px 24px ${glow}` : 'none',
        }}>{cta}</button>
      </div>
    </div>
  );
}

/* ─── AI Agent Features ──────────────────────────────────────────────────────── */
function AIAgentFeatures() {
  const features = [
    { icon: <Icon name="brain" />, title: 'Advanced AI Engine', desc: 'Ultra-fast AI responses powered by Groq + Llama 3.3 70B. Your bot replies in under 500ms, every time.' },
    { icon: <Icon name="book" />, title: 'Custom Knowledge Base', desc: 'Train your bot on your products, FAQs, policies. It answers exactly like your best sales rep would.' },
    { icon: <Icon name="target" />, title: 'Smart Lead Qualification', desc: 'Automatically capture name, phone, intent and score leads. Sync directly to your CRM or dashboard.' },
    { icon: <Icon name="calendar" />, title: 'Live Calendar Access', desc: 'Bot checks your Google Calendar in real time — meeting schedules, availability, upcoming events, all via WhatsApp.' },
    { icon: <Icon name="globe" />, title: 'Real-Time Web Search', desc: 'When the bot doesn\'t know, it searches the web using Tavily and brings back accurate, up-to-date answers instantly.' },
    { icon: <Icon name="plug" />, title: 'CRM & API Integrations', desc: 'Connect HubSpot, Notion, or any HTTP API. The bot reads your CRM live during conversations — zero copy-paste.' },
    { icon: <Icon name="handoff" />, title: 'Human Handoff', desc: 'Smart detection of complex queries. Seamlessly transfers to your team with full conversation context.' },
    { icon: <Icon name="settings" />, title: 'Custom API Tools', desc: 'Define any API as a bot tool — give it a name, schema, and auth. The AI calls it automatically when needed.' },
    { icon: <Icon name="users" />, title: 'Multi-Language Support', desc: 'Converse in Hindi, English, Tamil, Telugu, and 10+ regional languages without any setup.' },
    { icon: <Icon name="flag" />,    title: 'Intelligent Ticketing', desc: 'When the bot truly cannot resolve a query, it auto-raises a support ticket — complete with context. Your team replies and the answer goes straight back to the learner on WhatsApp.' },
    { icon: <Icon name="lock" />,    title: 'Learner DB Lookup', desc: 'Connect your PostgreSQL or MongoDB database. The support agent queries enrollment, fees and attendance data live before ever escalating to a human.' },
  ];

  return (
    <section id="features" className="mx-section-px" style={{ padding: '100px 40px', background: 'rgba(239,68,68,0.02)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="AI Agent" color="#ef4444" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Your 24/7 AI Sales &<br /><span style={{ color: '#ef4444' }}>Support Representative</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 500, margin: '0 auto' }}>
            Deploy once, convert forever. The AI never sleeps, never takes a break, and never misses a lead.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
          {features.map((f, i) => (
            <FeatureCard key={i} {...f} color="#ef4444" delay={i % 3 * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── Broadcaster Features ───────────────────────────────────────────────────── */
function BroadcasterFeatures() {
  const features = [
    { icon: <Icon name="upload" />, title: 'Unlimited Bulk Messaging', desc: 'Send to thousands of contacts in minutes. No daily limits, no throttling — just pure reach at scale.' },
    { icon: <Icon name="palette" />, title: 'Rich Media Campaigns', desc: 'Images, PDFs, videos, documents — create visually compelling messages that get noticed and clicked.' },
    { icon: <Icon name="users" />, title: 'Smart Contact Lists', desc: 'Import, segment, and manage your contact lists. Tag customers by behaviour, location, or purchase history.' },
    { icon: <Icon name="barchart" />, title: 'Real-Time Analytics', desc: 'Track delivery rates, open rates, and responses in real-time. Know exactly what\'s working.' },
    { icon: <Icon name="clock" />, title: 'Scheduled Campaigns', desc: 'Plan your campaigns in advance. Schedule by time zone, send at peak engagement hours automatically.' },
    { icon: <Icon name="shield" />, title: 'Anti-Ban Technology', desc: 'Message rotation, pacing algorithms, and account health monitoring to keep your number safe.' },
  ];

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="Broadcaster" color="#b91c1c" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Reach Thousands in<br /><span style={{ color: '#b91c1c' }}>Minutes, Not Days</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 500, margin: '0 auto' }}>
            The most powerful bulk WhatsApp messenger for Indian businesses. Compliant, scalable, and effective.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
          {features.map((f, i) => (
            <FeatureCard key={i} {...f} color="#b91c1c" delay={i % 3 * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ icon, title, desc, color, delay }) {
  const [h, setH] = useState(false);
  return (
    <div
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      className="mx-fade-up"
      style={{
        background: h ? `${color}08` : 'rgba(255,255,255,0.02)',
        border: `1px solid ${h ? `${color}25` : 'rgba(255,255,255,0.06)'}`,
        borderRadius: 18, padding: '28px 26px', transition: 'all 0.3s',
        transitionDelay: `${delay}s`,
      }}
    >
      <div style={{ marginBottom: 16 }}>{icon}</div>
      <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 10, color: h ? '#f1f5f9' : '#e2e8f0' }}>{title}</h3>
      <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.7 }}>{desc}</p>
    </div>
  );
}

/* ─── Support Agent Section ──────────────────────────────────────────────────── */
function SupportAgentSection() {
  const steps = [
    { n: '01', color: '#ef4444', title: 'Learner asks a question', desc: 'Any query comes in via WhatsApp — course fees, attendance, access issues, anything.' },
    { n: '02', color: '#dc2626', title: 'Agent resolves it automatically', desc: 'Checks the knowledge base, searches the web, queries your live learner database (PostgreSQL or MongoDB). Answers instantly if it can.' },
    { n: '03', color: '#f97316', title: 'Raises a ticket only if stuck', desc: 'If none of those sources have the answer, a numbered support ticket is created with full context. No spam tickets — only genuine escalations.' },
    { n: '04', color: '#22c55e', title: 'Human replies, learner notified', desc: 'Your support staff types the answer in the dashboard. One click and it\'s sent back to the learner as a WhatsApp message from the same bot number.' },
  ];

  const pillars = [
    { icon: <Icon name="brain" size={28} color="#ef4444" />, label: 'Knowledge Base First', color: '#ef4444' },
    { icon: <Icon name="globe" size={28} color="#dc2626" />, label: 'Web Search Fallback', color: '#dc2626' },
    { icon: <Icon name="building" size={28} color="#b91c1c" />, label: 'Live DB Query', color: '#b91c1c' },
    { icon: <Icon name="flag"  size={28} color="#f97316" />, label: 'Smart Ticket Escalation', color: '#f97316' },
    { icon: <Icon name="handoff" size={28} color="#22c55e" />, label: 'WhatsApp Reply Delivery', color: '#22c55e' },
  ];

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px', background: 'rgba(239,68,68,0.02)', borderTop: '1px solid rgba(239,68,68,0.08)', borderBottom: '1px solid rgba(239,68,68,0.08)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        {/* Header */}
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="Support Agent" color="#ef4444" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            AI That Resolves First.<br />
            <span style={{ color: '#ef4444' }}>Escalates Only When Needed.</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 560, margin: '0 auto', lineHeight: 1.75 }}>
            The support agent exhausts every option before raising a ticket. Learners get instant answers.
            Your team only sees issues that genuinely need a human.
          </p>
        </div>

        {/* Resolution ladder pills */}
        <div className="mx-fade-up" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 72 }}>
          {pillars.map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 18px', borderRadius: 100, background: `${p.color}12`, border: `1px solid ${p.color}30` }}>
              {p.icon}
              <span style={{ fontSize: 13, fontWeight: 600, color: p.color }}>{p.label}</span>
            </div>
          ))}
        </div>

        {/* 4-step flow */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 24, marginBottom: 72 }}>
          {steps.map((step, i) => (
            <div key={i} className="mx-fade-up" style={{ background: 'rgba(255,255,255,0.02)', border: `1px solid ${step.color}20`, borderRadius: 18, padding: '28px 24px', position: 'relative', overflow: 'hidden', transitionDelay: `${i * 0.1}s` }}>
              <div style={{ position: 'absolute', top: 16, right: 20, fontSize: 48, fontWeight: 900, color: step.color, opacity: 0.07, lineHeight: 1 }}>{step.n}</div>
              <div style={{ fontSize: 12, fontWeight: 800, color: step.color, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 12 }}>Step {step.n}</div>
              <h3 style={{ fontSize: 17, fontWeight: 700, color: '#f1f5f9', marginBottom: 10 }}>{step.title}</h3>
              <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.7 }}>{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Dashboard preview callout */}
        <div className="mx-fade-up" style={{ background: 'linear-gradient(135deg, rgba(239,68,68,0.08) 0%, rgba(185,28,28,0.04) 100%)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 20, padding: '36px 40px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 32 }}>
          <div style={{ flex: 1, minWidth: 260 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: '#ef4444', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 10 }}>Support Dashboard</div>
            <h3 style={{ fontSize: 22, fontWeight: 800, color: '#f1f5f9', marginBottom: 12 }}>Your team stays in control</h3>
            <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.75, marginBottom: 20 }}>
              A dedicated ticket panel shows every escalation — status, priority, learner info, and full conversation history. Staff reply once; the answer reaches the learner on WhatsApp automatically.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              {['Real-time ticket feed', 'Priority & status controls', 'Assign to team members', 'Internal notes', 'One-click WA delivery', 'DB connector config'].map((f, i) => (
                <span key={i} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 100, background: 'rgba(239,68,68,0.10)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.2)', fontWeight: 600 }}>{f}</span>
              ))}
            </div>
          </div>
          <div style={{ flex: '0 0 auto' }}>
            {/* Ticket card mock */}
            <div style={{ background: '#0f172a', border: '1px solid #1e293b', borderRadius: 14, padding: '20px 22px', width: 300, boxShadow: '0 8px 40px rgba(0,0,0,0.5)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <span style={{ fontSize: 11, color: '#64748b' }}>Support Ticket</span>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#f97316', background: '#f9731310', padding: '2px 8px', borderRadius: 4 }}>OPEN</span>
              </div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#f1f5f9', marginBottom: 6 }}>#12 — Fee payment not reflecting</div>
              <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>Priya Sharma &middot; +91 98765 43210</div>
              <div style={{ background: '#1e293b', borderRadius: 8, padding: '10px 12px', fontSize: 12, color: '#94a3b8', marginBottom: 14, lineHeight: 1.6 }}>
                "I paid the installment 3 days ago but my portal still shows outstanding balance..."
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <div style={{ flex: 1, height: 32, borderRadius: 6, background: '#22c55e15', border: '1px solid #22c55e30', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#22c55e' }}>Resolve & Send</span>
                </div>
                <div style={{ width: 32, height: 32, borderRadius: 6, background: '#334155', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>
                  <span style={{ color: '#94a3b8' }}>...</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

/* ─── How It Works ───────────────────────────────────────────────────────────── */
function HowItWorks() {
  const steps = [
    { n: '01', icon: <Icon name="building" size={40} />, title: 'Create Your Account', desc: 'Sign up in 2 minutes. Our team activates your WhatsApp Business API and onboards you within 24 hours.' },
    { n: '02', icon: <Icon name="settings" size={40} />, title: 'Configure Your Bot or Campaign', desc: 'Upload your knowledge base, set your bot\'s personality, or build your first broadcast campaign using our visual editor.' },
    { n: '03', icon: <Icon name="rocket" size={40} />, title: 'Go Live & Grow', desc: 'Scan the QR, connect your number, and start converting. Your AI agent handles queries while you track results live.' },
  ];

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px', background: 'rgba(185,28,28,0.02)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="How It Works" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Up & Running in<br /><span style={{ color: '#ef4444' }}>Under 24 Hours</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 480, margin: '0 auto' }}>
            No technical skills needed. Our team handles the setup — you just focus on growing your business.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 32, position: 'relative' }}>
          {steps.map((s, i) => (
            <div key={i} className={`mx-fade-up mx-delay-${i + 1}`} style={{
              background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: 20, padding: '36px 30px', position: 'relative', overflow: 'hidden',
            }}>
              <div style={{ fontSize: 64, fontWeight: 900, color: 'rgba(255,255,255,0.04)', position: 'absolute', top: 12, right: 16, lineHeight: 1, letterSpacing: -4, fontFamily: 'monospace' }}>{s.n}</div>
              <div style={{ marginBottom: 20 }}>{s.icon}</div>
              <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 12 }}>{s.title}</h3>
              <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.8 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── Pricing ────────────────────────────────────────────────────────────────── */
function PricingSection({ navigate, openLead }) {
  const plans = [
    {
      name: 'AI Agent',
      icon: <Icon name="bot" size={44} />,
      price: '₹10,000',
      period: '/month',
      color: '#ef4444',
      desc: 'Perfect for businesses that want to automate customer conversations and capture leads 24/7.',
      features: [
        '1 WhatsApp Number',
        'Unlimited AI conversations',
        'Custom knowledge base (up to 50 docs)',
        'Lead capture & dashboard',
        'Live chat takeover',
        'WhatsApp QR connect',
        'Email support',
        'Monthly performance report',
      ],
      cta: 'Get AI Agent →',
      onClick: () => openLead('AI Agent'),
      popular: false,
    },
    {
      name: 'AI Agent + Broadcaster',
      icon: <Icon name="zap" size={44} color="#b91c1c" />,
      price: '₹16,999',
      period: '/month',
      color: '#b91c1c',
      desc: 'The complete WhatsApp growth stack. AI conversations + bulk broadcasting in one platform.',
      features: [
        'Everything in AI Agent',
        'Unlimited bulk broadcasts',
        'Rich media campaigns',
        'Advanced contact management',
        'Campaign scheduling',
        'Delivery analytics',
        'Priority support',
        'Dedicated onboarding manager',
      ],
      cta: 'Get Full Stack →',
      onClick: () => openLead('Both'),
      popular: true,
    },
  ];

  return (
    <section id="pricing" className="mx-section-px" style={{ padding: '100px 40px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="Pricing" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Simple, Transparent<br /><span style={{ color: '#ef4444' }}>Pricing</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 480, margin: '0 auto' }}>
            No hidden fees. No setup charges. Cancel anytime. Annual billing available for 20% discount.
          </p>
        </div>

        <div style={{ display: 'flex', gap: 28, justifyContent: 'center', flexWrap: 'wrap' }}>
          {plans.map((plan, i) => (
            <PricingCard key={i} {...plan} />
          ))}
        </div>

        <div className="mx-fade-up" style={{ textAlign: 'center', marginTop: 40, fontSize: 14, color: '#475569' }}>
          Need a custom enterprise plan?{' '}
          <a href="mailto:support@acceleratorx.co" style={{ color: '#ef4444', textDecoration: 'none', fontWeight: 600 }}>Contact us →</a>
        </div>
      </div>
    </section>
  );
}

function PricingCard({ name, icon, price, period, color, desc, features, cta, onClick, popular }) {
  const [h, setH] = useState(false);
  return (
    <div
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      className="mx-fade-up"
      style={{
        width: 360, maxWidth: '100%',
        background: popular ? `linear-gradient(135deg, ${color}12, ${color}04)` : 'rgba(255,255,255,0.02)',
        border: `1px solid ${popular || h ? color + '40' : 'rgba(255,255,255,0.08)'}`,
        borderRadius: 24, padding: '40px 36px', position: 'relative',
        boxShadow: popular ? `0 20px 60px ${color}20` : h ? `0 10px 40px ${color}15` : 'none',
        transition: 'all 0.3s',
      }}
    >
      {popular && (
        <div style={{
          position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
          background: `linear-gradient(90deg, ${color}, #dc2626)`, padding: '5px 20px',
          borderRadius: 20, fontSize: 12, fontWeight: 700, color: '#0a0a0a', whiteSpace: 'nowrap',
        }}>
          ⭐ Most Popular
        </div>
      )}
      <div style={{ marginBottom: 16 }}>{icon}</div>
      <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>{name}</h3>
      <p style={{ fontSize: 14, color: '#64748b', marginBottom: 24, lineHeight: 1.6 }}>{desc}</p>
      <div style={{ marginBottom: 28 }}>
        <span style={{ fontSize: 44, fontWeight: 900, color }}>{price}</span>
        <span style={{ fontSize: 15, color: '#475569' }}>{period}</span>
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {features.map((f, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: '#94a3b8' }}>
            <span style={{ color, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <button onClick={onClick} style={{
        width: '100%', padding: '15px', borderRadius: 12, border: 'none',
        background: h || popular ? color : `${color}20`, color: h || popular ? '#0a0a0a' : color,
        fontSize: 15, fontWeight: 700, cursor: 'pointer', transition: 'all 0.25s',
        boxShadow: h || popular ? `0 8px 24px ${color}40` : 'none',
      }}>{cta}</button>
    </div>
  );
}

/* ─── Why Maxxcom ────────────────────────────────────────────────────────────── */
function WhyMaxxcom() {
  const reasons = [
    { icon: <Icon name="flag" size={32} />, title: 'Built for India', desc: 'Regional languages, Indian payment flows, local compliance — designed from ground up for Indian businesses.' },
    { icon: <Icon name="zap" size={32} />, title: 'Instant Deployment', desc: 'Go live in under 24 hours. Our team handles WhatsApp API setup, onboarding, and first campaign.' },
    { icon: <Icon name="lock" size={32} />, title: 'Enterprise Security', desc: 'Bank-grade encryption, data residency in India, ISO-compliant infrastructure. Your data stays yours.' },
    { icon: <Icon name="trending" size={32} />, title: 'Proven ROI', desc: 'Our clients average 40% higher lead conversion and 60% reduction in customer support costs.' },
    { icon: <Icon name="handshake" size={32} />, title: 'Dedicated Support', desc: 'Real humans available 9AM–9PM IST. WhatsApp support, video onboarding, and monthly reviews.' },
    { icon: <Icon name="plug" size={32} />, title: 'CRM Integrations', desc: 'Connect with Zoho, HubSpot, Salesforce, Freshdesk, and 20+ tools via webhooks and API.' },
  ];

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px', background: 'rgba(239,68,68,0.015)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="Why Maxxcom by AcceleratorX" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Why 500+ Businesses<br /><span style={{ color: '#ef4444' }}>Choose Maxxcom by AcceleratorX</span>
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
          {reasons.map((r, i) => (
            <div key={i} className={`mx-fade-up mx-delay-${(i % 3) + 1}`} style={{
              background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: 18, padding: '28px 26px', display: 'flex', gap: 18, alignItems: 'flex-start',
            }}>
              <div style={{ flexShrink: 0 }}>{r.icon}</div>
              <div>
                <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>{r.title}</h3>
                <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.7 }}>{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── Testimonials ───────────────────────────────────────────────────────────── */
function Testimonials() {
  const testimonials = [
    {
      name: 'Rajesh Mehta',
      role: 'Founder, Mehta Real Estate',
      location: 'Mumbai',
      avatar: 'RM',
      color: '#ef4444',
      stars: 5,
      text: '"Before Maxxcom, we were missing 60% of WhatsApp inquiries after hours. Now our AI bot qualifies leads 24/7. Revenue from WhatsApp increased by ₹8 lakh in the first quarter."',
    },
    {
      name: 'Priya Sharma',
      role: 'Head of Marketing, FashionHub',
      location: 'Delhi',
      avatar: 'PS',
      color: '#b91c1c',
      stars: 5,
      text: '"The Broadcaster is insane. We ran a Diwali campaign to 25,000 customers in 45 minutes. 34% open rate, 12% click-through — our best campaign performance ever."',
    },
    {
      name: 'Arjun Nair',
      role: 'CEO, HealthFirst Clinics',
      location: 'Bangalore',
      avatar: 'AN',
      color: '#ef4444',
      stars: 5,
      text: '"Patient appointment no-shows dropped by 70% since we deployed Maxxcom. The automated reminders and rescheduling bot handles 500+ appointments daily without human intervention."',
    },
  ];

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="Testimonials" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Real Results from<br /><span style={{ color: '#ef4444' }}>Real Businesses</span>
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
          {testimonials.map((t, i) => (
            <div key={i} className={`mx-fade-up mx-delay-${i + 1}`} style={{
              background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: 20, padding: '32px 28px', display: 'flex', flexDirection: 'column', gap: 20,
            }}>
              <div style={{ display: 'flex', gap: 4 }}>
                {Array(t.stars).fill(0).map((_, j) => (
                  <span key={j} style={{ color: '#f59e0b', fontSize: 16 }}>★</span>
                ))}
              </div>
              <p style={{ fontSize: 14.5, color: '#94a3b8', lineHeight: 1.8, flex: 1 }}>{t.text}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                <div style={{
                  width: 44, height: 44, borderRadius: '50%',
                  background: `${t.color}20`, border: `2px solid ${t.color}40`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 14, fontWeight: 800, color: t.color, flexShrink: 0,
                }}>{t.avatar}</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#f1f5f9' }}>{t.name}</div>
                  <div style={{ fontSize: 12, color: '#475569' }}>{t.role} · {t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── FAQ ────────────────────────────────────────────────────────────────────── */
function FAQSection() {
  const faqs = [
    {
      q: 'Does Maxxcom use the official WhatsApp Business API?',
      a: 'Maxxcom operates using WhatsApp Web-based automation with Puppeteer for its core bot functionality. This approach allows rapid deployment without lengthy API approval processes. For enterprise customers requiring official WABA, we offer dedicated onboarding.',
    },
    {
      q: 'Will my WhatsApp number get banned?',
      a: 'We have built-in anti-ban protections including message pacing, rotation algorithms, and account health monitoring. Following our guidelines, our customers maintain excellent account health. We also provide guidance on WhatsApp\'s usage policies.',
    },
    {
      q: 'How long does it take to set up?',
      a: 'Most businesses are live within 24 hours. After you sign up, our team contacts you within 2 hours, completes the WhatsApp connection, and runs your first test conversation — all in the same day.',
    },
    {
      q: 'Can I train the AI on my own business data?',
      a: 'Absolutely. You can upload product catalogues, FAQs, policies, and pricing documents. The AI will learn from your materials and answer customer questions accurately. You can update the knowledge base anytime from your dashboard.',
    },
    {
      q: 'What languages does the AI support?',
      a: 'The AI supports English, Hindi, Tamil, Telugu, Marathi, Gujarati, Kannada, Malayalam, Bengali, and Punjabi. It auto-detects the customer\'s language and responds accordingly.',
    },
    {
      q: 'Can I switch between the AI Agent and Broadcaster plan?',
      a: 'Yes. You can start with the AI Agent plan and upgrade to the full stack (Agent + Broadcaster) anytime. Upgrades are prorated. Contact our team for seamless migration.',
    },
    {
      q: 'Is there a free trial available?',
      a: 'We offer a 7-day pilot program for qualified businesses. Contact our team at support@acceleratorx.co or start the sign-up process and mention "pilot" — our sales team will set you up.',
    },
  ];

  return (
    <section id="faq" className="mx-section-px" style={{ padding: '100px 40px', background: 'rgba(185,28,28,0.02)' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionTag label="FAQ" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            Frequently Asked<br /><span style={{ color: '#ef4444' }}>Questions</span>
          </h2>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {faqs.map((item, i) => (
            <FAQItem key={i} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="mx-fade-up"
      style={{
        background: 'rgba(255,255,255,0.02)', border: `1px solid ${open ? 'rgba(239,68,68,0.2)' : 'rgba(255,255,255,0.06)'}`,
        borderRadius: 14, overflow: 'hidden', transition: 'border-color 0.25s',
      }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', padding: '20px 24px', background: 'transparent', border: 'none',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16,
          cursor: 'pointer', textAlign: 'left',
        }}
      >
        <span style={{ fontSize: 15, fontWeight: 600, color: '#f1f5f9', lineHeight: 1.5 }}>{q}</span>
        <span style={{
          fontSize: 20, color: open ? '#ef4444' : '#475569', flexShrink: 0,
          transition: 'transform 0.25s, color 0.25s',
          transform: open ? 'rotate(45deg)' : 'rotate(0)',
          display: 'inline-block',
        }}>+</span>
      </button>
      {open && (
        <div style={{
          padding: '0 24px 20px', fontSize: 14, color: '#64748b', lineHeight: 1.8,
          animation: 'slideInMsg 0.25s ease both',
        }}>{a}</div>
      )}
    </div>
  );
}

/* ─── CTA Banner ─────────────────────────────────────────────────────────────── */
function CTABanner({ navigate, openLead }) {
  const [h1, setH1] = useState(false);
  const [h2, setH2] = useState(false);
  return (
    <section className="mx-section-px" style={{ padding: '80px 40px' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div className="mx-fade-up" style={{
          background: 'linear-gradient(135deg, rgba(239,68,68,0.1) 0%, rgba(185,28,28,0.1) 100%)',
          border: '1px solid rgba(239,68,68,0.15)', borderRadius: 28, padding: '64px 48px',
          textAlign: 'center', position: 'relative', overflow: 'hidden',
        }}>
          {/* Background glow */}
          <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(239,68,68,0.08) 0%, transparent 70%)', top: '-20%', left: '-10%', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(185,28,28,0.1) 0%, transparent 70%)', bottom: '-10%', right: '-5%', pointerEvents: 'none' }} />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ fontSize: 14, color: '#ef4444', fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 16 }}>
              Start Today
            </div>
            <h2 style={{ fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 900, marginBottom: 20, letterSpacing: '-1px' }}>
              Your Competitors Are Already<br />Automating WhatsApp.
              <span style={{ color: '#ef4444' }}> Are You?</span>
            </h2>
            <p style={{ fontSize: 17, color: '#64748b', maxWidth: 540, margin: '0 auto 40px', lineHeight: 1.7 }}>
              Join 500+ Indian businesses using Maxxcom to automate customer conversations, send bulk campaigns, and grow revenue on WhatsApp.
            </p>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => openLead()}
                onMouseEnter={() => setH1(true)} onMouseLeave={() => setH1(false)}
                style={{
                  padding: '16px 36px', borderRadius: 12, border: 'none', fontSize: 16, fontWeight: 700, cursor: 'pointer', transition: 'all 0.25s',
                  background: h1 ? '#dc2626' : '#ef4444', color: '#fff',
                  boxShadow: h1 ? '0 12px 40px rgba(239,68,68,0.5)' : '0 6px 24px rgba(239,68,68,0.3)',
                }}
              >
                Start Free Trial — No Credit Card →
              </button>
              <a
                href="mailto:support@acceleratorx.co"
                onMouseEnter={() => setH2(true)} onMouseLeave={() => setH2(false)}
                style={{
                  padding: '16px 36px', borderRadius: 12, border: `1px solid ${h2 ? '#b91c1c' : 'rgba(255,255,255,0.1)'}`,
                  fontSize: 16, fontWeight: 700, cursor: 'pointer', transition: 'all 0.25s', textDecoration: 'none',
                  background: 'transparent', color: h2 ? '#ef4444' : '#94a3b8',
                }}
              >
                Talk to Sales
              </a>
            </div>
            <p style={{ marginTop: 20, fontSize: 13, color: '#374151' }}>
              7-day pilot available · Onboarding within 24 hours · Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── Footer ─────────────────────────────────────────────────────────────────── */
function Footer() {
  const year = new Date().getFullYear();
  const socials = [
    { label: 'LinkedIn',  href: 'https://www.linkedin.com/company/acceleratorxorg/', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg> },
    { label: 'Instagram', href: 'https://www.instagram.com/acceleratorxorg', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg> },
    { label: 'YouTube',   href: 'https://youtube.com/@acceleratorxorg', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.45A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.45a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg> },
    { label: 'Twitter',   href: 'https://x.com/acceleratorxorg', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg> },
  ];

  return (
    <footer style={{ borderTop: '1px solid rgba(255,255,255,0.06)', background: '#070a10' }}>

      {/* AcceleratorX Belt */}
      <div className="mx-section-px" style={{ borderBottom: '1px solid rgba(255,255,255,0.05)', padding: '28px 40px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{ fontSize: 12, color: '#374151', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase' }}>Brought to you by</span>
            <a href="https://acceleratorx.org" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
              <img src="/acceleratorx-logo.webp" alt="AcceleratorX" style={{ height: 28, objectFit: 'contain', filter: 'brightness(1.1)' }} />
              <span style={{ fontSize: 15, fontWeight: 800, color: '#f1f5f9', letterSpacing: '-0.3px' }}>AcceleratorX</span>
            </a>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {socials.map(s => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer" title={s.label}
                style={{ width: 36, height: 36, borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569', textDecoration: 'none', transition: 'all 0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#ef4444'; e.currentTarget.style.color = '#ef4444'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#475569'; }}
              >{s.icon}</a>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-section-px" style={{ padding: '56px 40px 36px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 48, marginBottom: 48 }}>

            {/* Brand */}
            <div>
              <img src="/maxxcom-logo.svg" alt="Maxxcom by AcceleratorX" style={{ height: 36, objectFit: 'contain', marginBottom: 14, display: 'block' }} />
              <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.8, marginBottom: 18 }}>
                India's most powerful AI WhatsApp platform. Automate conversations, scale outreach, and grow revenue — built by AcceleratorX.
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', borderRadius: 10, background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.12)', width: 'fit-content' }}>
                <img src="/acceleratorx-logo.webp" alt="AcceleratorX" style={{ height: 18, objectFit: 'contain' }} />
                <span style={{ fontSize: 12, fontWeight: 700, color: '#ef4444', letterSpacing: 0.3 }}>An AcceleratorX Product</span>
              </div>
            </div>

            {/* Product */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 700, color: '#f1f5f9', marginBottom: 18, letterSpacing: 1, textTransform: 'uppercase' }}>Product</h4>
              {[['AI WhatsApp Agent', '#products'], ['WhatsApp Broadcaster', '#products'], ['Pricing', '#pricing'], ['How It Works', '#how-it-works'], ['FAQ', '#faq']].map(([l, h]) => (
                <a key={l} href={h} style={{ display: 'block', fontSize: 14, color: '#475569', textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#ef4444'} onMouseLeave={e => e.target.style.color = '#475569'}>{l}</a>
              ))}
            </div>

            {/* Company */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 700, color: '#f1f5f9', marginBottom: 18, letterSpacing: 1, textTransform: 'uppercase' }}>Company</h4>
              {[['About AcceleratorX', 'https://acceleratorx.org'], ['LinkedIn', 'https://www.linkedin.com/company/acceleratorxorg/'], ['Privacy Policy', '#'], ['Terms of Service', '#']].map(([l, h]) => (
                <a key={l} href={h} target={h.startsWith('http') ? '_blank' : undefined} rel="noreferrer"
                  style={{ display: 'block', fontSize: 14, color: '#475569', textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#ef4444'} onMouseLeave={e => e.target.style.color = '#475569'}>{l}</a>
              ))}
            </div>

            {/* Contact */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 700, color: '#f1f5f9', marginBottom: 18, letterSpacing: 1, textTransform: 'uppercase' }}>Contact & Support</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {[
                  {
                    icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
                    label: 'support@acceleratorx.co', href: 'mailto:support@acceleratorx.co',
                  },
                  {
                    icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.01 2.19 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>,
                    label: '+91 99168 59555', href: 'tel:+919916859555',
                  },
                  {
                    icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
                    label: 'WhatsApp Us', href: 'https://wa.me/919916859555',
                  },
                  {
                    icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>,
                    label: 'HSR Layout, Bangalore', href: 'https://maps.google.com/?q=L367,5th+Main+Road,6th+Sector,HSR+Layout,Bangalore,KA+560102',
                  },
                ].map(({ icon, label, href }) => (
                  <a key={label} href={href} target={href.startsWith('http') || href.startsWith('https://wa') ? '_blank' : undefined} rel="noreferrer"
                    style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5, color: '#475569', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#ef4444'}
                    onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                    <span style={{ flexShrink: 0 }}>{icon}</span>
                    <span>{label}</span>
                  </a>
                ))}
                <div style={{ marginTop: 6, fontSize: 12, color: '#374151', lineHeight: 1.6 }}>
                  L367, 5th Main Road, 6th Sector,<br />HSR Layout, Bangalore — 560102
                </div>
              </div>
            </div>
          </div>

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <p style={{ fontSize: 13, color: '#374151' }}>
              © {year} Maxxcom by AcceleratorX. All rights reserved.
            </p>
            <p style={{ fontSize: 13, color: '#374151' }}>
              Made with ♥ in Bangalore, India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ─── Stats Belt ─────────────────────────────────────────────────────────────── */
function StatsBelt() {
  const stats = [
    { val: '500', suffix: '+', label: 'Businesses Onboarded', icon: 'building' },
    { val: '10',  suffix: 'M+', label: 'Messages Processed',  icon: 'barchart' },
    { val: '99.9', suffix: '%', label: 'Uptime SLA',           icon: 'shield' },
    { val: '24',  suffix: 'hr', label: 'Onboarding Time',      icon: 'clock' },
    { val: '6',   suffix: '+',  label: 'Live Integrations',    icon: 'plug' },
    { val: '10',  suffix: '+',  label: 'Languages Supported',  icon: 'globe' },
  ];

  return (
    <div className="mx-section-px" style={{
      borderTop: '1px solid rgba(255,255,255,0.05)',
      borderBottom: '1px solid rgba(255,255,255,0.05)',
      background: 'rgba(255,255,255,0.01)',
      padding: '0 40px', overflow: 'hidden', position: 'relative',
    }}>
      {/* Beam effect */}
      <div style={{
        position: 'absolute', top: 0, bottom: 0, width: '15%',
        background: 'linear-gradient(90deg, transparent, rgba(239,68,68,0.04), transparent)',
        animation: 'beamSweep 5s ease-in-out infinite', pointerEvents: 'none',
      }} />
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex', alignItems: 'stretch', justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}>
        {stats.map((s, i) => (
          <div
            key={i}
            className="mx-fade-up"
            style={{
              padding: '32px 20px', textAlign: 'center', flex: '1 1 140px',
              borderRight: i < stats.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
            }}
          >
            <div style={{ marginBottom: 6, display: 'flex', justifyContent: 'center' }}><Icon name={s.icon} size={22} color="#ef4444" /></div>
            <div style={{ fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 900, color: '#ef4444', lineHeight: 1, marginBottom: 6 }}>
              {s.val}<span style={{ fontSize: '0.6em', fontWeight: 800 }}>{s.suffix}</span>
            </div>
            <div style={{ fontSize: 12, color: '#475569', fontWeight: 500 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─── Video Showcase ─────────────────────────────────────────────────────────── */
const DEMO_VIDEOS = [
  {
    tag: 'Start Here', tagColor: '#ef4444',
    title: 'Platform Overview',
    desc: '24/7 lead qualification — from first message to booked appointment, fully automated.',
    component: PlatformOverviewDemo,
  },
  {
    tag: 'Integrations', tagColor: '#dc2626',
    title: 'AI Agent + Live Tools',
    desc: 'Watch the bot query Google Calendar, HubSpot CRM, and search the web in one conversation.',
    component: IntegrationsDemoVideo,
  },
  {
    tag: 'Broadcaster', tagColor: '#b91c1c',
    title: 'Bulk Campaign — Diwali',
    desc: 'Compose, send to 25,000 contacts, and see live analytics — end to end in 15 seconds.',
    component: BroadcasterDemo,
  },
];

function VideoShowcase() {
  const [active, setActive] = useState(0);
  const ActiveDemo = DEMO_VIDEOS[active].component;

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px', background: 'rgba(0,0,0,0.4)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 52 }}>
          <SectionTag label="Live Demos" color="#ef4444" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' }}>
            See Maxxcom<br /><span style={{ color: '#ef4444' }}>In Action</span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 500, margin: '0 auto' }}>
            Fully animated, live demos — running in your browser right now. No video file needed.
          </p>
        </div>

        {/* Tab switcher */}
        <div className="mx-fade-up" style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 32, flexWrap: 'wrap' }}>
          {DEMO_VIDEOS.map((v, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              style={{
                padding: '9px 22px', borderRadius: 10, fontSize: 13, fontWeight: 600,
                cursor: 'pointer', transition: 'all 0.25s', border: 'none',
                background: active === i ? v.tagColor : 'rgba(255,255,255,0.04)',
                color: active === i ? '#fff' : '#64748b',
                boxShadow: active === i ? `0 6px 24px ${v.tagColor}40` : 'none',
              }}
            >
              {v.title}
            </button>
          ))}
        </div>

        {/* Active demo */}
        <div className="mx-fade-up" style={{ borderRadius: 20, overflow: 'hidden', border: `1px solid ${DEMO_VIDEOS[active].tagColor}20`, boxShadow: `0 40px 100px rgba(0,0,0,0.5), 0 0 0 1px ${DEMO_VIDEOS[active].tagColor}15` }}>
          <ActiveDemo key={active} />
        </div>

        {/* Description strip */}
        <div style={{ display: 'flex', gap: 12, marginTop: 28, justifyContent: 'center', flexWrap: 'wrap' }}>
          {DEMO_VIDEOS.map((v, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              style={{
                background: active === i ? `${v.tagColor}12` : 'transparent',
                border: `1px solid ${active === i ? v.tagColor + '30' : 'rgba(255,255,255,0.06)'}`,
                borderRadius: 12, padding: '12px 18px', cursor: 'pointer', textAlign: 'left', maxWidth: 300,
                transition: 'all 0.25s',
              }}
            >
              <div style={{ fontSize: 12, fontWeight: 700, color: v.tagColor, marginBottom: 3 }}>{v.tag}</div>
              <div style={{ fontSize: 13, color: active === i ? '#f1f5f9' : '#475569' }}>{v.desc}</div>
            </button>
          ))}
        </div>

      </div>
    </section>
  );
}

/* ─── Integrations Showcase ──────────────────────────────────────────────────── */
function IntegrationsSection() {
  const tools = [
    {
      icon: 'calendar', name: 'Google Calendar',   color: '#4285f4',
      desc: 'Check meetings, events & availability in real time',
      status: 'live',
    },
    {
      icon: 'users', name: 'HubSpot CRM',       color: '#ff7a59',
      desc: 'Search contacts, deals & lead stages from chat',
      status: 'live',
    },
    {
      icon: 'globe', name: 'Web Search',         color: '#22c55e',
      desc: 'Auto-searches Tavily when the bot lacks an answer',
      status: 'live',
    },
    {
      icon: 'plug', name: 'Custom HTTP API',    color: '#ef4444',
      desc: 'Any endpoint — your own CRM, ERP, or internal tool',
      status: 'live',
    },
    {
      icon: 'book', name: 'Notion Databases',   color: '#94a3b8',
      desc: 'Query Notion pages and databases',
      status: 'soon',
    },
    {
      icon: 'barchart', name: 'Google Sheets',      color: '#94a3b8',
      desc: 'Read and write to sheets during conversations',
      status: 'soon',
    },
  ];

  const flow = [
    { step: 'User asks', icon: 'handoff', color: '#ef4444', desc: '"What\'s my 3 PM meeting about?"' },
    { step: 'Bot decides', icon: 'brain', color: '#dc2626', desc: 'Routes to Google Calendar tool' },
    { step: 'Tool runs', icon: 'zap', color: '#f59e0b', desc: 'Queries API in <200ms' },
    { step: 'Bot replies', icon: 'bot', color: '#22c55e', desc: 'Natural answer with live data' },
  ];

  return (
    <section className="mx-section-px" style={{ padding: '100px 40px', background: 'linear-gradient(180deg, rgba(239,68,68,0.02) 0%, rgba(0,0,0,0) 100%)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        {/* Header */}
        <div className="mx-fade-up" style={{ textAlign: 'center', marginBottom: 72 }}>
          <SectionTag label="Integrations" color="#ef4444" />
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 46px)', fontWeight: 900, marginBottom: 18, letterSpacing: '-1px' }}>
            Your Bot Knows<br />
            <span style={{ background: 'linear-gradient(90deg, #b91c1c, #ef4444)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Everything You Know
            </span>
          </h2>
          <p style={{ fontSize: 16, color: '#64748b', maxWidth: 560, margin: '0 auto' }}>
            Connect your calendar, CRM, databases and APIs. The bot queries them live during conversations — no copy-paste, no manual lookups.
          </p>
        </div>

        {/* Flow strip */}
        <div className="mx-fade-up" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0, marginBottom: 72, flexWrap: 'wrap' }}>
          {flow.map((f, i) => (
            <React.Fragment key={i}>
              <div style={{
                background: 'rgba(255,255,255,0.02)', border: `1px solid ${f.color}30`,
                borderRadius: 14, padding: '18px 22px', textAlign: 'center', minWidth: 140,
                transition: 'transform 0.3s',
              }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div style={{ marginBottom: 6, display: 'flex', justifyContent: 'center' }}><Icon name={f.icon} size={28} color={f.color} /></div>
                <div style={{ fontSize: 11, fontWeight: 700, color: f.color, letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 4 }}>{f.step}</div>
                <div style={{ fontSize: 12, color: '#64748b', lineHeight: 1.4 }}>{f.desc}</div>
              </div>
              {i < flow.length - 1 && (
                <div style={{ color: '#334155', fontSize: 20, padding: '0 8px', flexShrink: 0 }}>→</div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Tool grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 18, marginBottom: 56 }}>
          {tools.map((t, i) => (
            <div
              key={i}
              className="mx-fade-up"
              style={{
                background: t.status === 'soon' ? 'rgba(255,255,255,0.01)' : `linear-gradient(135deg, ${t.color}08 0%, transparent 100%)`,
                border: `1px solid ${t.status === 'soon' ? 'rgba(255,255,255,0.05)' : t.color + '25'}`,
                borderRadius: 16, padding: '22px 22px',
                display: 'flex', gap: 16, alignItems: 'flex-start',
                opacity: t.status === 'soon' ? 0.55 : 1,
                transition: 'all 0.3s',
              }}
              onMouseEnter={e => { if (t.status !== 'soon') e.currentTarget.style.transform = 'translateY(-3px)'; }}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: `${t.color}15`, border: `1px solid ${t.color}30`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}><Icon name={t.icon} size={22} color={t.status === 'soon' ? '#475569' : t.color} /></div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: t.status === 'soon' ? '#475569' : '#f1f5f9' }}>{t.name}</span>
                  <span style={{
                    fontSize: 9, fontWeight: 700, padding: '1px 7px', borderRadius: 20, letterSpacing: 0.5,
                    background: t.status === 'live' ? '#14532d' : '#1e293b',
                    color:      t.status === 'live' ? '#4ade80' : '#475569',
                    textTransform: 'uppercase',
                  }}>{t.status === 'live' ? 'Live' : 'Soon'}</span>
                </div>
                <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>{t.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="mx-fade-up glow-border" style={{
          background: 'linear-gradient(135deg, rgba(239,68,68,0.08) 0%, rgba(185,28,28,0.04) 100%)',
          border: '1px solid rgba(239,68,68,0.2)', borderRadius: 20,
          padding: '32px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: 24, flexWrap: 'wrap',
        }}>
          <div>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 6 }}>Need a custom integration?</h3>
            <p style={{ fontSize: 14, color: '#64748b' }}>Use the Custom API tool to connect any HTTP endpoint — takes 2 minutes to configure.</p>
          </div>
          <div className="mx-integrations-pills" style={{ display: 'flex', gap: 12, flexShrink: 0, flexWrap: 'wrap' }}>
            <div style={{ padding: '8px 18px', borderRadius: 10, background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.25)', fontSize: 13, color: '#fca5a5', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
              <Icon name="plug" size={14} color="#fca5a5" /> Any REST API
            </div>
            <div style={{ padding: '8px 18px', borderRadius: 10, background: 'rgba(185,28,28,0.15)', border: '1px solid rgba(185,28,28,0.3)', fontSize: 13, color: '#fca5a5', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
              <Icon name="lock" size={14} color="#fca5a5" /> Bearer · API Key · Basic Auth
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── Shared: SectionTag ─────────────────────────────────────────────────────── */
function SectionTag({ label, color = '#ef4444' }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 16,
      padding: '5px 14px', borderRadius: 20,
      background: `${color}12`, border: `1px solid ${color}25`,
      fontSize: 12, fontWeight: 700, color, letterSpacing: 1, textTransform: 'uppercase',
    }}>
      {label}
    </div>
  );
}
